package com.havn.app.core.media

import com.havn.app.core.supabase.HavnSupabaseConfig
import kotlin.math.absoluteValue

fun havnFullSizePropertyPhotoSource(storagePath: String?): String? {
    val path = storagePath?.takeIf { it.isNotBlank() } ?: return null
    if (path.startsWith("http://") || path.startsWith("https://")) return path
    if (path.startsWith("seed/")) return havnSeedPhotoUrl(path)
    return "${HavnSupabaseConfig.url}/storage/v1/object/public/${HavnSupabaseConfig.propertyPhotosBucket}/${path.encodeStoragePath()}"
}

fun havnLargePropertyPhotoSource(storagePath: String?, width: Int = 1800, quality: Int = 88): String? {
    val path = storagePath?.takeIf { it.isNotBlank() } ?: return null
    if (path.startsWith("http://") || path.startsWith("https://")) return path
    if (path.startsWith("seed/")) return havnSeedPhotoUrl(path)
    val safeWidth = width.coerceIn(900, 2400)
    val safeQuality = quality.coerceIn(65, 92)
    return "${HavnSupabaseConfig.url}/storage/v1/render/image/public/${HavnSupabaseConfig.propertyPhotosBucket}/${path.encodeStoragePath()}?width=$safeWidth&quality=$safeQuality&resize=cover"
}

private fun havnSeedPhotoUrl(storagePath: String): String =
    HavnSeedWebPhotoUrls[storagePath.hashCode().absoluteValue % HavnSeedWebPhotoUrls.size]

private fun String.encodeStoragePath(): String =
    split('/').joinToString("/") { segment ->
        buildString {
            segment.forEach { char ->
                when {
                    char in 'a'..'z' ||
                        char in 'A'..'Z' ||
                        char in '0'..'9' ||
                        char == '-' ||
                        char == '_' ||
                        char == '.' ||
                        char == '~' -> append(char)
                    char == ' ' -> append("%20")
                    else -> append('%').append(char.code.toString(16).uppercase().padStart(2, '0'))
                }
            }
        }
    }
